<template>
  <w-column v-bind="$props">
    <slot />
  </w-column>
</template>

<script>
import WorkColumn from "../grid/WorkColumn";

export default {
  name: "WorkDividedInContentWrapperColumn",
  props: {
    ...WorkColumn.props,
    cols: { type: [Boolean, String, Number], default: 12 }
  },
}
</script>
